import sdk from '@/sdk';
import * as store from '@/store';
import {ServerConfig} from '@/config/routers';

// 文档打印时上报日志
export function handleDocPrint(isPreviewMode: boolean) {
    const curDocument = store.getData(store.KEYS.CUR_DOCUMENT);
    const docVersion = curDocument?.version || '';
    const title = curDocument?.name || '';

    const logData: any = {
        name: title,
        type: '101',
    };

    // 预览态上报当前版本，编辑态和会议模式等内容实时变化的状态不传版本，由后端查询最近的历史版本
    if (isPreviewMode) {
        logData.version = docVersion;
    }

    // 调接口上报打印行为
    const tokenObj = store.getData(store.KEYS.CUR_DOCUMENT_TOKEN);
    const rteToken = tokenObj?.accessToken;
    if (!rteToken) {
        console.error('handleDocPrint: rteToken is null');
        return;
    }

    sdk.as.request({
        method: 'POST',
        url: `${ServerConfig.origin}/wiki/ai/dig/v1/export/pdf`,
        data: logData,
        headers: {
            Authorization: rteToken,
        },
    });
}
